export enum AccessPaths {
  Content = 'content',
  Requests = 'requests',
}

export enum AccessParams {
  RequestId = 'requestId',
}
